export class UcUnBlockedEvent extends Event {

  ucService: string
  ucId: string
  useBasicThumbnail: boolean

  constructor (ucId: string, ucService: string, useBasicThumbnail = false) {
    super('unBlocked')
    this.ucService = ucService
    this.ucId = ucId
    this.useBasicThumbnail = useBasicThumbnail
  }
}
